import React from 'react';
import packageJSON from '../../../package.json';

export default function FlagVersion() {
  if (process.env.REACT_APP_SHOW_VERSION === 'false') {
    return <span data-version={packageJSON.version} />;
  }

  return (
    <span
      style={{
        position: 'absolute',
        top: 6,
        left: 0,
        background: '#ddd',
        fontSize: 10,
        padding: '4px 8px',
        borderRadius: 50,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      }}
    >
      v{packageJSON.version}
    </span>
  );
}
